<template>
	<div
		v-if="loading"
		class="text-xs-center ma-4">
		<v-progress-circular
			:size="50"
			color="primary"
			indeterminate
		/>
	</div>
</template>

<script>
import { sync } from 'vuex-pathify';

export default {
	props: {
		loading: {
			default: false,
			type: Boolean,
		},
	},
	computed: {
		show: sync('loader/show'),
	},
};
</script>

<style>

</style>
